import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';
import { useTheme } from '../../../styles/ThemeProvider';
import { buildTooltipStyle } from './tooltipStyle';

export const TrendLine = ({ data, xKey = 'label', series = [], yFormatter }) => {
  const { theme } = useTheme();
  const tip = buildTooltipStyle(theme);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid stroke={theme.color.border} strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey={xKey} stroke={theme.color.muted} fontSize={12} tickLine={false} />
        <YAxis stroke={theme.color.muted} fontSize={12} tickLine={false} axisLine={false} tickFormatter={yFormatter} />
        <Tooltip {...tip} formatter={yFormatter ? (v) => yFormatter(v) : undefined} />
        {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
        {series.map((s, i) => (
          <Line
            key={s.key}
            type="monotone"
            dataKey={s.key}
            name={s.label}
            stroke={s.color || theme.chart.categorical[i % theme.chart.categorical.length]}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
            strokeDasharray={s.dashed ? '5 5' : undefined}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};
